import {defaultShouldDehydrateQuery, type Query} from '@tanstack/react-query';

/**
 * Keys whose queries are eligible for disk persistence.
 * Allow-list is intentionally broad — hooks for brands/segments/departments/promotions
 * are added in DIS-1202..1205. Allow-list is a no-op for keys not yet in cache.
 */
export const PERSIST_QUERY_KEYS = new Set<string>([
  'feed',
  'brands',
  'segments',
  'departments',
  'promotions',
]);

/** 24 hours. Persisted cache older than this is silently discarded on restore. */
export const PERSIST_MAX_AGE_MS = 1000 * 60 * 60 * 24;

/**
 * gcTime must be >= maxAge or TanStack GC's the query before the persister can write it.
 * Set equal to maxAge — queries stay in memory up to 24h when unobserved.
 */
export const PERSIST_GC_TIME_MS = 1000 * 60 * 60 * 24;

/**
 * Allow-list filter for dehydration.
 * Only success-state queries whose top-level key is in PERSIST_QUERY_KEYS are persisted.
 * Delegates remaining checks (status, error redaction) to TanStack default.
 */
export const shouldDehydrateQuery = (query: Query): boolean => {
  const topKey = query.queryKey[0];
  if (typeof topKey !== 'string' || !PERSIST_QUERY_KEYS.has(topKey)) return false;
  return defaultShouldDehydrateQuery(query);
};
